<template>
<div class="chapter">
<div class="inner_page">
<h2 id="_idParaDest-1"><a id="_idTextAnchor000"></a>Contents</h2>
<p class="firstleft"><a href="#/Text/foreword#_idTextAnchor001">Foreword by Mark Labberton</a></p>
<p class="firstleft"><a href="#/Text/intro#_idTextAnchor002">Introduction</a></p>
<p class="body_sa"><a href="#/Text/ch1#_idTextAnchor003">1 Biblical Preaching</a></p>
<p class="body_sa"><span href="#/Text/ch2#_idTextAnchor016" title="Link target outside of Sample">2 God-Centered Preaching</span></p>
<p class="body_sa"><span href="#/Text/ch3#_idTextAnchor033" title="Link target outside of Sample">3 Grace-full Preaching</span></p>
<p class="body_sa"><span href="#/Text/ch4#_idTextAnchor041" title="Link target outside of Sample">4 Compelling Preaching</span></p>
<p class="body_sa"><span href="#/Text/ch5#_idTextAnchor049" title="Link target outside of Sample">5 Imaginative Preaching</span></p>
<p class="body_sa"><span href="#/Text/ch6#_idTextAnchor055" title="Link target outside of Sample">6 Contextual Preaching</span></p>
<p class="body_sa"><span href="#/Text/ch7#_idTextAnchor060" title="Link target outside of Sample">7 Relevant Preaching</span></p>
<p class="body_sa"><span href="#/Text/ch8#_idTextAnchor062" title="Link target outside of Sample">8 Embodied Preaching</span></p>
<p class="body_sa"><span href="#/Text/ch9#_idTextAnchor065" title="Link target outside of Sample">9 Self-less Preaching</span></p>
<p class="body_sa"><span href="#/Text/ch10#_idTextAnchor068" title="Link target outside of Sample">10 Getting Feedback About Your Preaching</span></p>
<p class="firstleft"><span href="#/Text/conclusion#_idTextAnchor070" title="Link target outside of Sample">Conclusion</span></p>
<p class="firstleft"><span href="#/Text/acknowledgments#_idTextAnchor071" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="firstleft"><span href="#/Text/appendix#_idTextAnchor072" title="Link target outside of Sample">Appendix: Resources for Inspiration and Education</span></p>
<p class="firstleft"><span href="#/Text/notes#_idTextAnchor073" title="Link target outside of Sample">Notes</span></p>
<p class="firstleft"><span href="#/Text/praise#_idTextAnchor131" title="Link target outside of Sample">Praise for <i>A Little Handbook for Preachers</i></span></p>
<p class="firstleft"><span href="#/Text/author#_idTextAnchor132" title="Link target outside of Sample">About the Author</span></p>
<p class="firstleft"><span href="#/Text/praxis" title="Link target outside of Sample">IVP Praxis</span></p>
<p class="firstleft"><span href="#/Text/moreIVP#_idTextAnchor133" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
<p class="firstleft"><span href="#/Text/moreIVP#_idselector" title="Link target outside of Sample">IVP Textbook Selector</span></p>
<p class="firstleft"><span href="#/Text/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?65ffd952